import { Component, OnInit, Input, Output, EventEmitter, SimpleChanges, ViewChild, ElementRef } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatAutocompleteTrigger } from '@angular/material/autocomplete';
import { map, Observable, startWith } from 'rxjs';

@Component({
  selector: 'app-tags-selector-search',
  templateUrl: './tags-selector-search.component.html'
})
export class TagsSelectorSearchComponent implements OnInit {
  @Input() loading = true;
  @Input() isRequired = false;
  @Input() disabled = false;
  @Input() isSubmitted = false;
  @Input() list: any[] = [];
  @Input() label!: string;
  @Input() selectedMax!: number;
  @Output() selectedItems = new EventEmitter<any[]>();
  @Output() addNewItemRequest = new EventEmitter<string>();
  @ViewChild('input', { static: false }) input!: ElementRef<HTMLInputElement>;
  @Input() showAddOption = false;
  @ViewChild(MatAutocompleteTrigger) autocompleteTrigger!: MatAutocompleteTrigger;

  searchCtr = new FormControl<string | any>('');
  filteredList!: Observable<any[]>;
  @Input() selectedList: any;

  valueToAdd = '';

  constructor() { }

  ngOnInit(): void {
    window.addEventListener('scroll', this.onWindowScroll, true);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['loading']?.currentValue == false) {
      this.initListFiltiration();
    }
    if (changes['isSubmitted']?.currentValue && this.isRequired) {
      this.hasError();
    }
  }

  prepareToAdd(value: string) {
    this.valueToAdd = value;
  }

  onAddNewItem() {
    const trimmed = this.valueToAdd.trim();
    if (!trimmed) return;

    this.addNewItemRequest.emit(trimmed);
    this.searchCtr.setValue('');
  }

  initListFiltiration() {
    this.filteredList = this.searchCtr.valueChanges.pipe(
      startWith(''),
      map(value => {
        const name = typeof value === 'string' ? value : value?.name;
        return name ? this._filter(name as string) : this.list?.slice();
      }),
    );
  }
  displayFn(item: any): string {
    return item && item.name ? item.name : '';
  }
  private _filter(name: string): any[] {
    const filterValue = name.toLowerCase();
    return this.list.filter(item => item.name.toLowerCase().includes(filterValue));
  }
  selected(value: any) {
    if (!this.isSelected(value)) {
      this.selectedList.push(value);
    } else {
      let index = this.selectedList.findIndex((item: any) => item.id === value.id)
      if (index >= 0) {
        this.selectedList.splice(index, 1);
      }
    }
    this.searchCtr.setValue('');
    this.selectedItems.emit(this.selectedList);
    this.hasError();
  }
  removeSelected(i: number) {
    this.selectedList.splice(i, 1);
    this.selectedItems.emit(this.selectedList);
    this.hasError();
  }
  isSelected(v: any) {
    return this.selectedList.some((item: any) => item.id === v.id)
  }

  hasError() {
    if (!this.selectedList.length && this.isRequired) {
      this.searchCtr.setErrors({ required: true });
    } else {
      this.searchCtr.setErrors(null);
    }
    this.searchCtr.markAsTouched()
  }

  handleEnter(value: string, event: any): void {
    if (this.showAddOption && value?.trim()) {
      event.preventDefault();
      event.stopPropagation();
      this.prepareToAdd(value);
      this.onAddNewItem();
      setTimeout(() => this.autocompleteTrigger.closePanel(), 0);
    }
  }

  onWindowScroll = (event: Event) => {
    const panel = document.querySelector('.mat-autocomplete-panel');
    const target = event.target as HTMLElement;

    if (!panel) return;

    // If the scroll event target is *not* the autocomplete panel or a child of it
    if (!panel.contains(target)) {
      this.autocompleteTrigger.closePanel();
    }
  };
  
  ngOnDestroy(): void {
    window.removeEventListener('scroll', this.onWindowScroll, true);
  }


}
